import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import 'components/PropertyImageGallery/PropertyImageGallery.scss';
import PropertyImageGallery from 'components/PropertyImageGallery/PropertyImageGallery';
import PlaceholderImage from 'images/no-image@2x.png';
import {comparableTypes, getFetchingFromState, getPropertyFromState} from 'lib/PropertyUtils';
import {isEmpty} from 'lodash/lang';
import {fetchComparablePropertyPhotos} from 'actionCreators/propertyFetchingActions';
import {PHOTO_GALLERY_FIELDS} from 'lib/Commons';

const mapStateToProps = (state, ownProps) => {
  const {featureFlags} = state;
  const {images = [], isLoading: propsIsLoading, propertyId, comparableType} = ownProps;
  const isComparable = comparableType !== undefined ? !!comparableType : propertyId !== state.propertyDetail?.propertyId;
  const property = getPropertyFromState(propertyId, comparableType, state);

  let isLoading;
  if (!featureFlags.rapidSearchEnabled) {
    isLoading = false;
  } else if (!propertyId || !property || (isComparable && !comparableType)) {
    isLoading = true;
  } else {
    if (typeof propsIsLoading !== 'undefined') {
      isLoading = propsIsLoading;
    } else if (isEmpty(images) || images.includes(PlaceholderImage)) {
      isLoading = true;
    } else {
      isLoading = getFetchingFromState({
        propertyId,
        comparableType,
        state,
        updateFields: PHOTO_GALLERY_FIELDS,
      });
    }
  }

  let collectedImages = images;

  if (isLoading) {
    collectedImages = property && property.propertyPhotoUri
      ? [property.propertyPhotoUri]
      : [];
  }
  return {
    ...ownProps,
    featureFlags,
    isComparable,
    isLoading,
    property,
    images: collectedImages,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    onFetchPropertyPhotos: (
      {
        address,
        isComparable,
        latitude,
        longitude,
      }
    ) => {
      return dispatch(fetchComparablePropertyPhotos({
        address,
        isComparable,
        comparableType: props.comparableType,
        latitude,
        longitude,
        propertyId: props.propertyId,
      })).catch(e => {
        // Ignore lazy load rejections for now
        console.warn('Failed to fetch', e);
      });
    },
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  const {featureFlags: {rapidSearchEnabled}, isComparable} = stateProps;
  const {singleLineAddress, latitude, longitude} = stateProps.property ?? {};

  return {
    ...stateProps,
    ...dispatchProps,
    onFetchPropertyPhotos: () => {
      if (rapidSearchEnabled) {
        dispatchProps
            .onFetchPropertyPhotos({
              address: singleLineAddress,
              isComparable,
              latitude,
              longitude,
            });
      }
    }
  };
};

const PropertyImageGalleryContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(PropertyImageGallery);

export { PropertyImageGalleryContainer, PropertyImageGallery };

PropertyImageGalleryContainer.propTypes = {
  comparableType: PropTypes.oneOf(comparableTypes),
  currentIndex: PropTypes.number,
  deletableImages: PropTypes.arrayOf(PropTypes.string),
  hasModal: PropTypes.bool,
  images: PropTypes.arrayOf(PropTypes.string),
  inlineGalleryProps: PropTypes.object,
  isLoading: PropTypes.bool,
  modalProps: PropTypes.object,
  objectContext: PropTypes.string,
  pageContext: PropTypes.string,
  placeholder: PropTypes.string,
  propertyId: PropTypes.number,
  resizeProps: PropTypes.shape({
    isResize: PropTypes.bool,
    resizeDimensions: PropTypes.shape({
      height: PropTypes.number,
      width: PropTypes.number,
    }),
  }),
  onIndexChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
  onUpload: PropTypes.func,
};
export default PropertyImageGalleryContainer;
